<template>
  <section id="s-company-info">
    <SettingsLeftSideBar :options="tabOptions" :activeTab="activeTab" :change="changeTab" />
    <PartnerInfoSection
      v-if="activeTab === 'info'"
      :change="changeTab"
      :currentCorporation="currentCorporation"
      :partnerIndustry="partnerIndustry"
      :update="update"
      :screen="screen"
      :partnerSettings="partnerSettings"
      :updatePartnerSetting="updatePartnerSetting"
    />
    <ContactsSection
      v-else-if="activeTab === 'contact'"
      :currentCorporation="currentCorporation"
      :update="update"
      :change="changeTab"
    />
    <div v-else-if="activeTab === 'addresses'" class="s-addresses-container">
      <BusinessAddressSection
        :currentCorporation="currentCorporation"
        :update="update"
        :states="states"
      />
      <BillingAddressSection
        :billingAddresses="currentCorporation.billingAddress || []"
        :update="updateAddress"
        :states="states"
      />
      <ShippingAddressSection
        :shippingAddresses="currentCorporation.shippingAddress || []"
        :update="updateAddress"
        :states="states"
      />
    </div>
    <BillingSettingSection
      v-else-if="activeTab === 'billingSetting'"
      :screen="screen"
      :change="changeTab"
      :corpId="currentCorporation.id"
      :partnerSettings="partnerSettings"
      :taxExemptCategory="taxExemptCategory"
      :update="updatePartnerSetting"
      :selectedPaymentMethod="selectedPaymentMethod"
      :loadingPaymentMethod="loadingPaymentMethod"
      :toggleActionModal="toggleActionModal"
    />
    <AgreementSection
      v-else-if="activeTab === 'agreements'"
      :screen="screen"
      :agreements="agreements"
      :toggleActionModal="toggleActionModal"
    />
    <UnitPreferencesSection
      v-else-if="activeTab === 'unitsPreferencesSetting'"
      :partnerSettings="partnerSettings"
      :update="updatePartnerSetting"
      :corpId="currentCorporation.id"
    />
    <SupportContactSection
      v-else-if="activeTab === 'supportContact'"
      :partnerSettings="partnerSettings"
      :update="updatePartnerSetting"
    />
    <BrandingSection
      v-if="activeTab === 'branding'"
      :currentCorporation="currentCorporation"
      :partnerSettings="partnerSettings"
      :update="updatePartnerSetting"
      :uploadLogo="updateLogo"
      :toggleActionModal="toggleActionModal"
    />
    <ProviderPlanSection
      v-if="activeTab === 'plan'"
      :currentCorporation="currentCorporation"
      :partnerSettings="partnerSettings"
      :toggleActionModal="toggleActionModal"
      :update="update"
      :updateSettings="updatePartnerSetting"
    />
    <OffersSection
      v-if="activeTab === 'offers'"
      :currentCorporation="currentCorporation"
      :partnerSettings="partnerSettings"
      :toggleActionModal="toggleActionModal"
      :update="update"
      :updateSettings="updatePartnerSetting"
    />
    <LeadSettingSection
      v-else-if="activeTab === 'lead'"
      :partnerSettings="partnerSettings"
      :update="updatePartnerSetting"
    />
    <AlertPreferenceSection
      v-else-if="activeTab === 'alert'"
      :partnerSettings="partnerSettings"
      :update="updatePartnerSetting"
      :alertOptions="alertOptions"
    />
    <ServiceRequestSection
      v-else-if="activeTab === 'request'"
      :currentCorporation="currentCorporation"
      :partnerSettings="partnerSettings"
      :serviceCategoryList="serviceCategoryList"
      :update="updatePartnerSetting"
    />
    <TechChatSection
      v-else-if="activeTab === 'chat'"
      :partnerSettings="partnerSettings"
      :currentCorporation="currentCorporation"
      :update="updatePartnerSetting"
    />
    <FilterPurchaseSection
      v-else-if="activeTab === 'filter'"
      :partnerSettings="partnerSettings"
      :currentCorporation="currentCorporation"
      :update="updatePartnerSetting"
    />
    <MaintenanceSection
      v-else-if="activeTab === 'maintenance'"
      :partnerSettings="partnerSettings"
      :update="updatePartnerSetting"
    />
    <PlatformUserTable
      v-else-if="activeTab === 'dashboardUsers'"
      :currentCorporationP="currentCorporation"
      :toggleModal="toggleModal"
    />
    <AccountSection
      v-else-if="activeTab === 'account'"
      :currentCorporation="currentCorporation"
      :partnerIndustry="partnerIndustry"
      :partnerSettings="partnerSettings"
      :updatePartnerSetting="updatePartnerSetting"
      :update="update"
      :screen="screen"
    />
    <IntegrationsInfo
      v-else-if="activeTab === 'integrations'"
      :partnerSettings="partnerSettings"
      :currentCorporation="currentCorporation"
      :update="updatePartnerSetting"
      :screen="screen"
      :changeStateValue="changePartnerSettingsValue"
    />
    <OrderTable v-else-if="activeTab === 'order'" />
    <ActionModal />
  </section>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import launchDarklyClient from '@shared/lib/general/launchDarklyClient';

import PlatformUserTable from '@shared/components/setting/PlatformUserTable.vue';
import PartnerInfoSection from './companyInfo/PartnerInfoSection.vue';
import BusinessAddressSection from './companyInfo/BusinessAddressSection.vue';
import BillingAddressSection from './companyInfo/BillingAddressSection.vue';
import ShippingAddressSection from './companyInfo/ShippingAddressSection.vue';
import BillingSettingSection from './companyInfo/BillingSettingSection.vue';
import UnitPreferencesSection from './companyInfo/UnitPreferencesSection.vue';
import SupportContactSection from './companyInfo/SupportContactSection.vue';
import AgreementSection from './companyInfo/AgreementSection.vue';
import OrderTable from './companyInfo/OrderTable.vue';
import ActionModal from '../partnerSettings/ActionModal.vue';
import SettingsLeftSideBar from './components/SettingsLeftSideBar.vue';
import ProviderPlanSection from './platformSetting/ProviderPlanSection.vue';
import BrandingSection from './platformSetting/BrandingSection.vue';
import LeadSettingSection from './platformSetting/LeadSettingSection.vue';
import ServiceRequestSection from './platformSetting/ServiceRequestSection.vue';
import TechChatSection from './platformSetting/TechChatSection.vue';
import FilterPurchaseSection from './platformSetting/FilterPurchaseSection.vue';
import MaintenanceSection from './platformSetting/MaintenanceSection.vue';
import AlertPreferenceSection from './platformSetting/AlertPreferenceSection.vue';
import IntegrationsInfo from './IntegrationsInfo.vue';
import AccountSection from './platformSetting/AccountSection.vue';
import ContactsSection from './platformSetting/ContactsSection.vue';
import OffersSection from './platformSetting/OffersSection.vue';

export default {
  name: 'CompanyInfo',
  components: {
    SettingsLeftSideBar,
    PartnerInfoSection,
    BusinessAddressSection,
    BillingAddressSection,
    ShippingAddressSection,
    BillingSettingSection,
    UnitPreferencesSection,
    SupportContactSection,
    AgreementSection,
    ProviderPlanSection,
    BrandingSection,
    LeadSettingSection,
    AlertPreferenceSection,
    ServiceRequestSection,
    TechChatSection,
    FilterPurchaseSection,
    MaintenanceSection,
    PlatformUserTable,
    ActionModal,
    IntegrationsInfo,
    AccountSection,
    ContactsSection,
    OrderTable,
    OffersSection,
  },
  mixins: [partnerSettingsMixin],
  props: {
    screen: String,
    currentCorporation: Object,
    partnerSettings: Object,
    serviceCategoryList: Array,
    alertOptions: Array,
    partnerIndustry: Array,
    update: Function,
    updateAddress: Function,
    updateLogo: Function,
    updatePartnerSetting: Function,
    states: Array,
    countries: Array,
    taxExemptCategory: Array,
    selectedPaymentMethod: Array,
    agreements: Array,
    loadingPaymentMethod: Boolean,
    toggleActionModal: Function,
  },
  data() {
    return {
      activeTab: 'info',
    };
  },
  computed: {
    tabOptions() {
      const generalOptions = [
        {
          label: 'Company Information',
          value: 'info',
        },
        {
          label: 'Billing',
          value: 'billingSetting',
        },
      ];
      if (this.screen === 'partnerDetail') {
        generalOptions.push({
          label: 'Orders',
          value: 'order',
        });
      }
      generalOptions.push(
        {
          label: 'Agreements',
          value: 'agreements',
        },
        {
          label: 'Addresses',
          value: 'addresses',
        },
        {
          label: 'Partner Contacts',
          value: 'contact',
        },
        {
          label: 'Dashboard Users',
          value: 'dashboardUsers',
        },
      );
      let options = [
        {
          label: 'General',
          subOptions: generalOptions,
        },
        {
          label: 'Platform',
          subOptions: [
            {
              label: 'Branding',
              value: 'branding',
            },
            {
              label: 'Plans',
              value: 'plan',
            },
            {
              label: 'Offers',
              value: 'offers',
            },
            {
              label: 'Unit Preferences',
              value: 'unitsPreferencesSetting',
            },
            {
              label: 'Opportunities',
              value: 'lead',
            },
            {
              label: 'Alert Preference',
              value: 'alert',
            },
            {
              label: 'Service Requests',
              value: 'request',
            },
            {
              label: 'Filter Purchase',
              value: 'filter',
            },
            {
              label: 'Tech Chat',
              value: 'chat',
            },
            {
              label: 'Integrations',
              value: 'integrations',
            },
            {
              label: 'Maintenance',
              value: 'maintenance',
            },
          ],
        },
      ];
      if (this.screen !== 'partnerDetail') {
        options = [
          ...options,
          {
            label: 'Personal',
            subOptions: [
              {
                label: 'My Profile',
                value: 'account',
              },
              {
                label: 'Log Out',
                value: 'logout',
              },
            ],
          },
        ];
      }
      return options;
    },
  },
  watch: {
    showWarningOnExit(nv) {
      if (!nv && this.warningTab) {
        this.activeTab = this.warningTab;
      }
    },
    '$route.query': {
      handler(nv) {
        if (nv) {
          let setting = null;
          Object.keys(nv).forEach((q) => {
            if (q?.toLowerCase() === 'setting') {
              setting = nv[q];
            }
          });
          if (setting) {
            const activeSideTab = this.tabOptions.find((j) =>
              j.subOptions.find((o) => o.value.toLowerCase() === setting.toLowerCase()),
            );
            if (activeSideTab) {
              this.activeTab = setting.toLowerCase();
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.$route?.query) {
      let setting = null;
      Object.keys(this.$route.query).forEach((q) => {
        if (q?.toLowerCase() === 'setting') {
          setting = this.$route.query[q];
        }
      });
      if (setting) {
        const activeSideTab = this.tabOptions.find((j) =>
          j.subOptions.find((o) => o.value.toLowerCase() === setting.toLowerCase()),
        );
        if (activeSideTab) {
          this.activeTab = setting.toLowerCase();
        }
      }
    }
  },
  methods: {
    changeTab(tab) {
      if (tab === 'logout') {
        this.$store.dispatch('logoutAdmin');
        launchDarklyClient.close();
        localStorage.clear();
        this.$intercom.shutdown();
        this.$router.push('/login');
      } else if (this.showWarningOnExit) {
        this.toggleModal(true, 'warning-save', tab);
      } else {
        this.changePartnerSettingsValue('warningTab', '');
        this.activeTab = tab;
      }
    },
  },
};
</script>

<style lang="scss">
section#s-company-info {
  display: flex;
  flex: 1;
  background-color: $WHITE;
  padding-top: 15px;
  .sac-lsb-option {
    padding-left: 100px;
  }
  .icn-btn {
    color: $NBLUE110;
    border-radius: 4px;
    padding: 10px 16px;
    border: 2px solid $NBLUE110;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
  }
  .fill-btn {
    margin-left: 12px;
    color: white;
    background-color: $NBLUE110;
    border-radius: 4px;
    padding: 10px 16px;
    border: 2px solid $NBLUE110;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
  }
  .del-btn {
    color: $TOMATO200;
    border-radius: 4px;
    padding: 10px 16px;
    border: 2px solid $TOMATO200;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
  }
  .s-addresses-container {
    width: 100%;
    padding-right: 40px;

    .s-address-container {
      border-radius: 4px;
      border: 1px solid #c4c5cc;
      display: flex;
      padding: 10px 16px;
      flex-direction: row;
      width: fit-content;
      margin-right: 20px;
      margin-top: 10px;
    }

    .address-icn-btn {
      color: $NBLUE110;
      border-radius: 4px;
      padding: 10px 16px;
      border: 2px solid $NBLUE110;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }
    .address-fill-btn {
      margin-left: 12px;
      color: white;
      background-color: $NBLUE110;
      border-radius: 4px;
      padding: 10px 16px;
      border: 2px solid $NBLUE110;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }
    .address-del-btn {
      color: $TOMATO200;
      margin-left: 12px;
      border-radius: 4px;
      padding: 10px 16px;
      border: 2px solid $TOMATO200;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }
  }

  .s-setting-container {
    padding: 20px;
    display: grid;
    align-content: flex-start;
    gap: 20px;
    width: 100%;
    position: relative;
    margin: 20px;
    height: fit-content;
    border: 1px solid var(--Borders-border, #c4c5cc);
    &.no-border {
      border: 0px !important;
    }

    .main-header {
      font-weight: 700;
      font-size: 1.25rem;
      color: $N100;
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      justify-content: space-between;

      .buttons-container {
        margin-bottom: 30px;
      }

      .sub-header {
        font-weight: normal;
        color: $N40;
        padding: 10px 0px;
        font-size: 1rem;
      }

      .save-btn {
        font-weight: 700;
        margin-bottom: 10px;
      }

      .cancel-btn {
        font-weight: 700;
        margin-bottom: 10px;
      }
    }
  }

  .ac-input-container,
  .ac-row-container {
    max-width: 500px;
  }
}
</style>
